const getters = {
  isLoading: state => state.isLoading,
  features: state => state.features,
  warnedOnce: state => state.warnedOnce,
};

export default getters;
